import React from 'react'

import styles from './styles.module.scss'

const DmvSectionTwo: React.FC = () => {
  return (
    <section id="full-veteran-services" className={styles.section}>
      <div className={styles.container}>
        <h2 className={styles.heading}>Full Veteran Services in the DMV</h2>
        <p className={styles.subtitle}>
          We provide complete funeral and memorial services for veterans and their families, with a
          deep understanding of military traditions, honors, and benefits.
        </p>

        <div className={styles.columns}>
          <div className={styles.imageColumn}>
            <img
              src="/veteran-services/full-vet-services.jpg"
              alt="Military pallbearers at Arlington National Cemetery"
              className={styles.image}
            />
          </div>

          <div className={styles.copyColumn}>
            <h3 className={styles.subheading}>Military Honors, Fully Coordinated</h3>
            <p className={styles.body}>
              We provide complete funeral and memorial services for veterans and their families,
              with a deep understanding of military traditions, honors, and benefits.
            </p>

            <h3 className={styles.subheading}>All Arrangements, Handled in One Place</h3>
            <p className={styles.body}>
              We arrange all military honors on your behalf, including flag presentation, Taps, and
              coordination with the appropriate military branch.
            </p>

            <h3 className={styles.subheading}>Guidance Through VA Benefits</h3>
            <p className={styles.body}>
              We help you understand eligibility, gather required documentation, and navigate
              available VA benefits with clarity and care.
            </p>

            <h3 className={styles.subheading}>
              Meaningful Services That Reflect a Life of Service
            </h3>
            <p className={styles.body}>
              We work with your family to create a service that honors your loved one&apos;s legacy,
              traditions, and personal story.
            </p>

            <h3 className={styles.subheading}>Planning Ahead, Thoughtfully</h3>
            <p className={styles.body}>
              We help veterans and their families make arrangements in advance, ensuring wishes are
              clear and decisions are easier when the time comes.
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default DmvSectionTwo
